import React, { useEffect, useState } from "react";
import { Button, Row, Col, Form, Checkbox, notification, message, Spin } from "antd";
import { awsService, containerService, destinationService, dropdownService, vehicleService } from "../../../services";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from "dayjs";
import ImageUploader from "../../../components/ImageUploader";
import { VEHICLES } from "../../../constants";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";
import MaterialLikeDatePicker from "../../../components/MaterialLikeDatePicker";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import { changeDocumentTitle } from "../../../utils/title";

const enginetypes = [
  {
    id: "1",
    name: "GASOLINE",
  },
  {
    id: "2",
    name: "HYBRID",
  },
  {
    id: "3",
    name: "EV",
  },
];

const BOS = [
  {
    id: "1",
    name: "Auction",
  },
  {
    id: "2",
    name: "Notarized",
  },
  {
    id: "3",
    name: "Non-Notarized",
  },
];

const car_status = [
  {
    value: "AT YARD",
    label: "AT YARD"
  },
  {
    value: "LOAD PLAN",
    label: "LOAD PLAN"
  },
  {
    value: "LOADED",
    label: "LOADED"
  },
  {
    value: "RETURNED",
    label: "RETURNED"
  },
]

const keys = [
  {
    value: "YES",
    label: "YES"
  },
  {
    value: "NO",
    label: "NO"
  },
  {
    value: "BROKEN",
    label: "BROKEN"
  }
]

function VehicleEdit() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [isGlobexVehicle, setIsGlobexVehicle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submiteLoading, setSubmitLoading] = useState(false);
  const [vehicle, setVehicle] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [containerSize, setContainerSize] = useState([]);
  const [towing, setTowing] = useState([]);
  const [vehicleType, setVehicleType] = useState([]);
  const [customers, setCustomers] = useState([])
  const [globexCustomer, setGlobexCustomer] = useState([])

  const [fileList, setFileList] = useState([]);
  const [removedImages, setRemovedImages] = useState([]);
  const [globexMeta, setGlobexMeta] = useState({
    globex_customer_id: null,
    globex_customer_name: null,
  });

  const handleChange = (info) => {
    let updatedFileList = [...info.fileList];
    // Check if total file count exceeds 50
    if (updatedFileList.length > 50) {
      message.error("File limit exceeded! You can only upload up to 50 files.");
      return;
    }

    // CHANGES HIGHLIGHTED: Handle removed files
    if (info.file.status === "removed") {
      const removedFile = info.file;

      if (removedFile.url) {
        setRemovedImages((prev) => [...prev, removedFile.url]);
      }
    }

    setFileList(updatedFileList);
  };

  const onFinish = async (values) => {
    // setLoading(true);
    setSubmitLoading(true)
    let images = [];

    if (fileList.length > 0) {
      const newFiles = fileList.filter((file) => file.originFileObj);

      if (newFiles.length > 0) {
        images = await awsService.uploadS3Bucket(
          newFiles,
          vehicle.username,
          values.chasis_no,
          VEHICLES
        );
      }

      const existingImages = fileList
        .filter((file) => file.url && !removedImages.includes(file.url)) // CHANGES HIGHLIGHTED: Exclude removed images
        .map((file) => file.url);

      images = [...images, ...existingImages];
    }

    // CHANGES HIGHLIGHTED: Delete removed images from AWS S3
    if (removedImages.length > 0) {
      await awsService.deleteFromS3Bucket(removedImages);
    }

    const data = {
      ...values,
      images,
      removedImages,
      date_rcd: values.date_rcd ? values.date_rcd.format("YYYY-MM-DD") : null,
      arrival_date: values.arrival_date ? values.arrival_date.format("YYYY-MM-DD") : null,
      globex_customer_id:
        globexMeta.globex_customer_id ?? vehicle?.globex_customer_id ?? null,

      globex_customer_name:
        globexMeta.globex_customer_name ?? vehicle?.globex_customer_name ?? null,
    };
    const response = await vehicleService.updateVehicle(id, data);
    setSubmitLoading(false)

    // setLoading(false);

    if (response.success) {
      notification.success({
        message: "Updated Vehicle Successfully",
        description: response.message,
        placement: "topRight",
      });
      setRemovedImages([]);
      navigate('/vehicle')
      // loadData();
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const getDestination = async () => {
    const { success, data } = await destinationService.fetchDestination();
    if (success) {
      setDestinations(data);
    }
  };

  const getContainerSize = async () => {
    const { success, data } = await containerService.fetchsizes();
    if (success) {
      setContainerSize(data);
    }
  };

  const getVehicleType = async () => {
    const { success, data } = await dropdownService.VehicleTypes();
    if (success) {
      setVehicleType(data);
    }
  };

  const getTowingLocations = async () => {
    const { success, data } = await dropdownService.towingLocation();
    if (success) {
      setTowing(data);
    }
  };

  const getCustomer = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      const filter = response.data.sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );

      const capitalizedFilter = filter.map((customer) => ({
        ...customer,
        name: customer.name.toUpperCase(),
      }));
      setCustomers(capitalizedFilter);
    }
  };
  const getGlobexCustomer = async () => {
    const response = await dropdownService.fetchGlobexCustomer();
    if (response.success) {
      setGlobexCustomer(response.data);
    }
  };

  const loadData = async () => {
    setLoading(true);
    // setSubmitLoading(true)

    const { success, data } = await vehicleService.view(id);
    if (success) {
      setVehicle(data.vehicle);
      setGlobexMeta({
        globex_customer_id: data.vehicle?.globex_customer_id ?? null,
        globex_customer_name: data.vehicle?.globex_customer_name ?? null,
      });

      if (data.vehicle?.is_globex_vehicle === 1) {
        setIsGlobexVehicle(true);
      }
      if (data.images) {
        const fileList = data.images.map((image) => ({
          uid: image.id.toString(),
          name: image.filename.substring(image.filename.lastIndexOf("/") + 1),
          status: "done",
          url: image.filename,
        }));

        setFileList(fileList);
      }

      form.setFieldsValue({
        ...data.vehicle,
        date_rcd: data.vehicle.date_rcd ? dayjs(data.vehicle.date_rcd).tz() : null,
        arrival_date: data.vehicle.arrival_date ? dayjs(data.vehicle.arrival_date).tz() : null,
      });
    }


    setLoading(false);
    // setSubmitLoading(true)

  };

  useEffect(() => {
    changeDocumentTitle("Edit Vehicle")
    getCustomer();
    getGlobexCustomer()
    getDestination();
    getContainerSize();
    getVehicleType();
    getTowingLocations();
    loadData();
  }, []);


  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-[60vh]">
          <Spin loading={loading} />
        </div>
      ) : (
        <Row gutter={16}>
          <Col span={5}>
            <div
              style={{
                paddingTop: "8px",
                paddingRight: "8px",
                paddingLeft: 8,
              }}
            >
              <ImageUploader
                fileList={fileList}
                beforeUpload={true}
                handleChange={handleChange}
                setFileList={setFileList}
                setRemovedImages={setRemovedImages}
                length={100}
              />

            </div>
          </Col>
          <Col span={19}>
            <div
              style={{
                padding: "15px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#FFFFFF",
              }}
            >
              <Row gutter={24}>
                <Form
                  // requiredMark={false}
                  layout="vertical"
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{ layout: "vertical" }}
                >
                  <Row gutter={24} style={{ padding: 20 }}>
                    <Col span={8}>
                      <Form.Item
                        // label="Users"
                        name="user_id"
                      >
                        <MaterialLikeSelect
                          label="Users"
                          required
                          value={form.getFieldValue("user_id")}
                          onChange={(value) => {
                            const selectedCustomer = customers.find(c => c.id === value);

                            form.setFieldValue("user_id", value);

                            if (selectedCustomer?.is_globex_customer === 1) {
                              setIsGlobexVehicle(true);
                              setGlobexMeta(prev => ({
                                ...prev,
                              }));
                            } else {
                              setIsGlobexVehicle(false);
                              setGlobexMeta({
                                globex_customer_id: null,
                                globex_customer_name: null,
                              });
                            }
                          }}
                          options={customers.map(c => ({
                            value: c.id,
                            label: c.name
                          }))}

                          readOnly={(vehicle?.car_status)?.toLowerCase() === "loaded" || vehicle?.is_globex_vehicle === 1} // disable when loaded
                        />
                      </Form.Item>

                    </Col>

                    {isGlobexVehicle && (
                      <Col span={8}>
                        <Form.Item name="globex_customer_id">
                          <MaterialLikeSelect
                            label="Globex Customer"
                            value={form.getFieldValue("globex_customer_id")}
                            onChange={(value) => {
                              const globex = globexCustomer.find(g => g.id === value);

                              setGlobexMeta({
                                globex_customer_id: value,
                                globex_customer_name: globex?.name || "",
                              });
                            }}
                            options={globexCustomer.map(g => ({
                              value: g.id,
                              label: g.name
                            }))}
                          />
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={8}>
                      <Form.Item
                        name="destination"
                      >
                        <MaterialLikeSelect
                          label="Destination"
                          value={form.getFieldValue("destination")}
                          onChange={(value) => form.setFieldValue("destination", value)}
                          options={destinations?.map((dest) => ({
                            key: dest.id,
                            value: dest.id,
                            label: dest.name,
                          }))}
                        />
                        {/* <Select
                          placeholder="Select Destination"
                          showSearch
                          optionFilterProp="children"
                        >
                          {destinations?.map((dest) => (
                            <Select.Option key={dest.id} value={dest.id}>
                              {dest.name}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="container_size"
                      >
                        <MaterialLikeSelect
                          label="Container Size"
                          value={form.getFieldValue("container_size")}
                          onChange={(value) => form.setFieldValue("container_size", value)}
                          options={containerSize?.map((size) => ({
                            key: size.id,
                            value: size.id,
                            label: size.name,
                          }))}
                        />
                        {/* <Select placeholder="">
                          {containerSize?.map((size) => (
                            <Select.Option key={size.id} value={size.id}>
                              {size.name}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="towing_location"
                      >
                        <MaterialLikeSelect
                          label="Towing Location"
                          value={form.getFieldValue("towing_location")}
                          onChange={(value) => form.setFieldValue("towing_location", value)}
                          options={towing?.map((tow) => ({
                            key: tow.id,
                            value: tow.id,
                            label: tow.auctions,
                          }))}
                        />
                        {/* <Select
                          placeholder=""
                          showSearch
                          optionFilterProp="children"
                        >
                          {towing?.map((tow) => (
                            <Select.Option key={tow.id} value={tow.id}>
                              {tow.auctions}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="date_rcd"
                        rules={[
                          { required: true, message: "Please select a date" },
                        ]}
                      >
                        <MaterialLikeDatePicker
                          label="Date Received"
                          required
                          value={form.getFieldValue("date_rcd")}
                          onChange={(date) => form.setFieldValue("date_rcd", date)}
                        />
                        {/* <DatePicker style={{ width: "100%" }} /> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="vehicle_type"
                        rules={[
                          {
                            required: true,
                            message: "Please input!",
                          },
                        ]}
                      >
                        <MaterialLikeSelect
                          label="Vehicle Type"
                          required
                          value={form.getFieldValue("vehicle_type")}
                          onChange={(value) => form.setFieldValue("vehicle_type", value)}
                          options={vehicleType?.map((type) => ({
                            key: type,
                            value: type,
                            label: type,
                          }))}
                        />
                        {/* <Select placeholder="car">
                          {vehicleType?.map((type) => (
                            <Select.Option key={type} value={type}>
                              {type}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="engine_type"
                      >
                        <MaterialLikeSelect
                          label="Engine Type"
                          value={form.getFieldValue("engine_type")}
                          onChange={(value) => form.setFieldValue("engine_type", value)}
                          options={enginetypes?.map((type) => ({
                            key: type.id,
                            value: type.name,
                            label: type.name,
                          }))}
                        />
                        {/* <Select placeholder="Select Engine Type" allowClear>
                          {enginetypes.map((type) => (
                            <Select.Option key={type.id} value={type.name}>
                              {type.name}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name="BOS"
                      >
                        <MaterialLikeSelect
                          label="BOS"
                          value={form.getFieldValue("BOS")}
                          onChange={(value) => form.setFieldValue("BOS", value)}
                          options={BOS?.map((b) => ({
                            key: b.id,
                            value: b.id,
                            label: b.name,
                          }))}
                        />
                        {/* <Select placeholder="Select BOS" allowClear>
                          {BOS.map((b) => (
                            <Select.Option key={b.id} value={b.id}>
                              {b.name}
                            </Select.Option>
                          ))}
                        </Select> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="car_status"
                        rules={[{
                          required: true,
                          message: "Please Select!",
                        }]}>
                        <MaterialLikeSelect
                          label="Car Status"
                          required
                          value={form.getFieldValue("car_status")}
                          onChange={(value) => form.setFieldValue("car_status", value)}
                          options={car_status?.map((status) => ({
                            key: status.value,
                            value: status.value,
                            label: status.label,
                          }))}
                        />
                        {/* <Select>
                          {car_status.map((status) => (
                            <Select.Option key={status.value} value={status.value}>
                              {status.label}
                            </Select.Option>
                          ))}
                        </Select> */}
                        {/* <Input placeholder="At yard" /> */}
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="lot_#">
                        <MaterialLikeInput
                          label="Lot #"
                          value={form.getFieldValue("lot_#")}
                          onChange={(e) => form.setFieldValue("lot_#", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="invoice_no">
                        <MaterialLikeInput
                          label="Invoice No"
                          value={form.getFieldValue("invoice_no")}
                          onChange={(e) => form.setFieldValue("invoice_no", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="invoice_amount">
                        <MaterialLikeInput
                          label="Invoice Amount"
                          value={form.getFieldValue("invoice_amount")}
                          onChange={(e) => form.setFieldValue("invoice_amount", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="product" rules={[
                        { required: true, message: "Please select a product" },
                      ]}>
                        <MaterialLikeInput
                          required
                          label="Product"
                          value={form.getFieldValue("product")}
                          onChange={(e) => form.setFieldValue("product", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="vehicle"
                        rules={[
                          { required: true, message: "Please select a vehicle" },
                        ]}>
                        <MaterialLikeInput
                          required
                          label="Vehicle"
                          value={form.getFieldValue("vehicle")}
                          onChange={(e) => form.setFieldValue("vehicle", e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="year"
                        rules={[
                          { required: true, message: "Please select a year" },
                        ]}
                      >
                        <MaterialLikeInput
                          required
                          label="Year"
                          value={form.getFieldValue("year")}
                          onChange={(e) => form.setFieldValue("year", e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="chasis_no"
                        rules={[
                          { required: true, message: "Please select a year" },
                        ]}
                      >
                        <MaterialLikeInput
                          required
                          label="Chassis No"
                          value={form.getFieldValue("chasis_no")}
                          onChange={(e) => form.setFieldValue("chasis_no", e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="value">
                        <MaterialLikeInput
                          label="Value"
                          value={form.getFieldValue("value")}
                          onChange={(e) => form.setFieldValue("value", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="weight">
                        <MaterialLikeInput
                          label="Weight"
                          value={form.getFieldValue("weight")}
                          onChange={(e) => form.setFieldValue("weight", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="operating_port">
                        <MaterialLikeInput
                          label="Operating Port"
                          value={form.getFieldValue("operating_port")}
                          onChange={(e) => form.setFieldValue("operating_port", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="booking_no">
                        <MaterialLikeInput
                          label="Booking No"
                          value={form.getFieldValue("booking_no")}
                          onChange={(e) => form.setFieldValue("booking_no", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="carrier_name">
                        <MaterialLikeInput
                          label="Carrier Name"
                          value={form.getFieldValue("carrier_name")}
                          onChange={(e) => form.setFieldValue("carrier_name", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="storage">
                        <MaterialLikeInput
                          label="Storage"
                          value={form.getFieldValue("storage")}
                          onChange={(e) => form.setFieldValue("storage", e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="bol">
                        <MaterialLikeInput
                          label="Bol"
                          value={form.getFieldValue("bol")}
                          onChange={(e) => form.setFieldValue("bol", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="title_owner">
                        <MaterialLikeInput
                          label="Title Owner"
                          value={form.getFieldValue("title_owner")}
                          onChange={(e) => form.setFieldValue("title_owner", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="title">
                        <MaterialLikeInput
                          label="Title"
                          value={form.getFieldValue("title")}
                          onChange={(e) => form.setFieldValue("title", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="title_number">
                        <MaterialLikeInput
                          label="Title Number"
                          value={form.getFieldValue("title_number")}
                          onChange={(e) => form.setFieldValue("title_number", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="title_state">
                        <MaterialLikeInput
                          label="Title State"
                          value={form.getFieldValue("title_state")}
                          onChange={(e) => form.setFieldValue("title_state", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="keys">
                        <MaterialLikeSelect
                          label="Keys"
                          required
                          value={form.getFieldValue("keys")}
                          onChange={(value) => form.setFieldValue("keys", value)}
                          options={keys?.map((key) => ({
                            key: key.value,
                            value: key.value,
                            label: key.label,
                          }))}
                        />
                        {/* <Select>
                          {keys.map((key) => (
                            <Select.Option key={key.value} value={key.value}>
                              {key.label}
                            </Select.Option>
                          ))}
                        </Select> */}
                        {/* <Input placeholder="yes" /> */}
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="notes">
                        <MaterialLikeInput
                          label="Notes"
                          value={form.getFieldValue("notes")}
                          onChange={(e) => form.setFieldValue("notes", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="container_no">
                        <MaterialLikeInput
                          label="Container No"
                          value={form.getFieldValue("container_no")}
                          onChange={(e) => form.setFieldValue("container_no", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="tracking_no">
                        <MaterialLikeInput
                          label="Tracking No"
                          value={form.getFieldValue("tracking_no")}
                          onChange={(e) => form.setFieldValue("tracking_no", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={16}>
                      <Form.Item name="arrival_date">
                        <MaterialLikeDatePicker
                          label="Arrival Date"
                          value={form.getFieldValue("arrival_date")}
                          onChange={(date) => form.setFieldValue("arrival_date", date)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="release_status">
                        <MaterialLikeInput
                          label="Release Status"
                          value={form.getFieldValue("release_status")}
                          onChange={(e) => form.setFieldValue("release_status", e.target.value)}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="file_ref">
                        <MaterialLikeInput
                          label="File Ref"
                          // readOnly={true}
                          value={form.getFieldValue("file_ref")}
                          onChange={(e) => form.setFieldValue("file_ref", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item name="shipping_class_id">
                        <MaterialLikeInput
                          label="Shipping Class Id"
                          value={form.getFieldValue("shipping_class_id")}
                          onChange={(e) => form.setFieldValue("shipping_class_id", e.target.value)}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={6} className="mt-2">
                      <Form.Item
                        style={{ textAlign: "left" }}
                        name="cutting_car"
                        valuePropName="checked"
                        normalize={(value) => (value ? 1 : 0)}
                      >
                        <Checkbox>Is Cutting Car?</Checkbox>
                      </Form.Item>
                    </Col>


                    <Col span={12} className="mt-4 mb-20">
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ width: "100%" }}
                        loading={submiteLoading}
                      >
                        Update Vehicle
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Row>
            </div >
          </Col >
        </Row >
      )
      }
    </>
  );
}
export default VehicleEdit;
